export class Semaphore {
  private queue: (() => void)[] = [];
  private locked: boolean = false;

  /**
   * Acquires a lock. If the semaphore is already locked, it queues the request.
   * Returns a promise that resolves when the lock is acquired.
   */
  public acquire(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.locked) {
        this.locked = true;
        resolve();
      } else {
        this.queue.push(resolve);
      }
    });
  }

  /**
   * Releases the lock. If there are queued tasks, it dequeues and resolves the next task.
   */
  public release(): void {
    if (this.queue.length > 0) {
      const next = this.queue.shift();
      if (next) {
        next();
      }
    } else {
      this.locked = false;
    }
  }
}
